var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkateanlaeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.419,3.372a.862.862,0,1,0-.967-.743A.863.863,0,0,0,7.419,3.372Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.833,6.7c.084.2.206.328.423.3a.706.706,0,0,0,.12-.035.447.447,0,0,0,.2-.611l-.121-.637L6.2,5.272l.035-.024.068.74L6.37,7.525,6.091,8.948s.071,2.267.076,2.3a.542.542,0,0,0,.1.284.466.466,0,0,0,.243.17.5.5,0,0,0,.362-.019.537.537,0,0,0,.249-.224A6.87,6.87,0,0,0,7.2,9.733l.367-1.347.381-.061.637,1.049s.284,1.613.3,1.649a.583.583,0,0,0,.184.235.5.5,0,0,0,.395.083.526.526,0,0,0,.308-.213c.032-.043-.146-2.388-.146-2.388L8.657,6.967l.055.049L8.621,5.589l-.007-.421,2.469.981a.486.486,0,0,0,.643-.218.41.41,0,0,0-.21-.577L8.186,3.66a.411.411,0,0,0-.245-.045l-1.274.09a.485.485,0,0,0-.247.09L4.612,5.154a.487.487,0,0,0-.155.576Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.965,10.872a.334.334,0,0,0-.354.332c-.007.015-.064.066-.216.1-.5.1-5.726.761-6.1.791a.472.472,0,0,1-.325-.07.355.355,0,0,0-.5.007.36.36,0,0,0,0,.5,1.1,1.1,0,0,0,.763.274c.038,0,.077,0,.117,0,.4-.034,5.637-.7,6.177-.8.62-.124.785-.528.785-.747A.376.376,0,0,0,11.965,10.872Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,12.923a.448.448,0,1,0,.448.448A.448.448,0,0,0,6.2,12.923Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.166,
    cy: 12.776,
    r: 0.448,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkateanlaeg);
export default __webpack_public_path__ + "static/media/SKATEANLAEG.6c6abf64e3b17add0c3efa75e4f6cda4.svg";
export { ForwardRef as ReactComponent };